import Avatar from "./avatar.jsx";
import pure from "./higher-order/pure";
import React from "react";
import { FormattedDateRelative } from "./formatted-date-relative";

export default pure(function TournamentChatsFeedItem({ tournamentChat, user }) {
  var createdAt = tournamentChat.get("created_at");
  var time = "";
  if (createdAt) {
    time = <FormattedDateRelative date={new Date(createdAt)} />;
  }
  return (
    <li className="chat_item">
      <div className="chat_avatar">
        <Avatar tiny user={user} />
      </div>

      <div className="chat_message">
        <div className="chat_name">
          <span>
            {user.get("username")}
          </span>

          <span className="chat_meta">
            {time}
          </span>
        </div>

        <div className="chat_body">
          {tournamentChat.get("message")}
        </div>
      </div>
    </li>
  );
});
